export const withdrawPaymentSwitching = {
  withdrawPaymentSwitching: 'Withdraw Transaction',
  username: 'Username',
  paymentName: 'PaymentName',
  refCode1: 'Ref Code 1',
  status: 'Status',
  transactionId: 'Transaction ID',
  refCode3: 'Ref Code 3',
  createdAt: 'Created At',
  advanceFilter: 'Advance Filter',
  requestedAmount: 'Requested Amount',
  amount: 'Amount',
  message: 'Message',
  feeAmount: 'Fee Amount',
  finalAmount: 'Final Amount',
  reviewReason: 'เหตุผลที่ CM ต้องตรวจสอบ',
  adminDecisionReviewReason: 'รอ Admin ของ CM ตัดสินใจ',
  financeHoldReviewReason: 'รอตรวจสอบผลการกันยอดครั้งแรกกับระบบการเงิน',
  financeDispatchReviewReason: 'รอตรวจสอบผลการบันทึกยอดกับระบบการเงิน',
  financeReleaseReviewReason: 'รอตรวจสอบผลการคืนยอดคงค้างกับระบบการเงิน',
  providerOutcomeReviewReason: 'ยังไม่ทราบผลคำขอที่ส่งไป P2Pay',
  providerPendingReviewReason: 'คำขอที่ส่งไป P2Pay ยังอยู่ระหว่างดำเนินการ',
  requestP2PayCancellation: 'ขอยกเลิกรายการกับ P2Pay',
  requestingP2PayCancellation: 'กำลังส่งคำขอ...',
  p2PayCancellationWaitingCallback: 'รอ callback จาก P2Pay',
  p2PayCancellationNeedsReconciliation: 'ไม่ทราบผล — รอตรวจสอบ',
  confirmP2PayCancellation: 'ยืนยันส่งคำขอยกเลิกรายการนี้ไปยัง P2Pay หรือไม่? P2Pay เป็นผู้ตัดสินว่ายกเลิกได้หรือไม่ และ CM จะรอ callback จาก P2Pay ก่อนอัปเดตสถานะสุดท้าย ห้ามกดซ้ำระหว่างรอผล',
  p2PayCancellationAccepted: 'P2Pay รับคำขอยกเลิกแล้ว สถานะสุดท้ายยังรอ callback จาก P2Pay',
  p2PayCancellationUnknown: 'ยังไม่ทราบผลคำขอยกเลิก ห้ามกดซ้ำ กรุณาตรวจสอบสถานะกับ P2Pay และรอ callback',
  p2PayCancellationRejected: 'P2Pay ไม่อนุญาตให้ยกเลิกในสถานะปัจจุบัน ระบบรีเฟรชรายการแล้ว',
  p2PayCancellationFailed: 'ส่งคำขอยกเลิกไปยัง P2Pay ไม่สำเร็จ ระบบไม่ได้ลองส่งซ้ำ',
  p2PayCancellationRefreshFailed: 'คำสั่งเสร็จแล้ว แต่รีเฟรชรายการไม่สำเร็จ กรุณาโหลดหน้าใหม่ก่อนดำเนินการอีกครั้ง',
}
